import { StatusCode } from '../config';
import { APIResponse } from '../models';

export const hasServerError = <T, E>(response: APIResponse<T, E>) => {
    if (!response || !response.response) {
        return false;
    }

    return response.response.status >= StatusCode.ServerError;
};
